/**
 * The emailed "Email me a code" link lands on /?signin=<token>. A care-package
 * sign-in link carries ?inv= too and belongs to the care landing, not here.
 */
export function accountSigninToken(query) {
  if (!query || query.inv) return ''
  const v = Array.isArray(query.signin) ? query.signin[0] : query.signin
  return v ? String(v) : ''
}
